import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { Typography, TextField, MenuItem } from '@material-ui/core';
import { IsNoU } from 'common/utils';

const useStyles = makeStyles(theme => ({
  root: {
  },
  row: {
//    height: '62px',
    display: 'flex',
    alignItems: 'center',
    // '& > *': {
    //   margin: theme.spacing(1),
    // },
  },
  itemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  itemInput: {
    width: '224px',
  },
}));

const SelectAgencyClient = props => {
  const { 
    className, 
    agencies,
    clients,
    valueAgency,
    onChangeAgency, 
    valueClient,
//    onSetValueClient,
    onChangeClient,
    style, 
    ...rest } = props;

  const classes = useStyles();

//  const [agencyClients, setAgencyClients] = useState([]);

  // const handleChangeAgency = (e) => {
  //   let newAgencyClients = clients.filter(client => client.agency === e.target.value);
  //   console.log('new agency clients ->');
  //   console.log(newAgencyClients);
  //   setAgencyClients(newAgencyClients);
  //   onSetValueClient('');
  //   onChangeAgency(e);
  // }

  // useEffect(() => {
  //   console.log('componentDidUpdate & selectedTemplates changed');
  //   if (!IsNoU(agencies) && agencies.lengh > 0) {
  //     let newAgencyClients = clients.filter(client => client.agency === agencies[0].name);
  //     console.log('new agency clients ->');
  //     console.log(newAgencyClients);
  //     setAgencyClients(newAgencyClients);
  //   }
  //   else {
  //     setAgencyClients([]);
  //   }
  // }, [agencies]);


  return (
    <div className={classes.row}>

        <TextField
          className={classes.itemInput}
          id="id-select-agency"
          required 
          select
          label="광고대행사"
          value={valueAgency}
          onChange={onChangeAgency} //{e=> handleChangeAgency(e)}
          helperText=""
          //variant="outlined"
          margin="dense"
        >
          {agencies.map(agency => (
            <MenuItem key={agency.id} value={agency.name}>
              {agency.name}
            </MenuItem>
          ))}
        </TextField>

        <div style={{width: 36}}>

        </div>

        <TextField
          className={classes.itemInput}
          id="id-select-client"
          required 
          select
          label="광고주"
          value={valueClient}
          onChange={onChangeClient}
          helperText=""
          //variant="outlined"
          margin="dense"
          helperText="* 광고대행사선택후 선택하세요"
        >
          {/* {console.log(agencyClients)} */}
          {clients.map(client => (
            <MenuItem key={client.id} value={client.name}>
              {client.name}
            </MenuItem>
          ))}
        </TextField>

      </div>
  );
};

SelectAgencyClient.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

export default SelectAgencyClient;
